import { message } from "antd";
import { GET, POST, PUT } from "../../../services/api";
import { ApiUrl } from "../../../ApiHelper/ApiUrl";
import { clientTypes } from "../../type/clientTypes";
import { toast } from "react-toastify";
import { cleanObject } from "../../../utils/commonFunctions";

export const getProfileData = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: clientTypes.GET_PROFILE_DATA_PENDING,
        isLoading: true,
      });
      const cleanedPayload = cleanObject(payload);
      const res = await GET(
        `${ApiUrl.CLIENT_PROFILE_DATA_GET}`,
        cleanedPayload
      );
      dispatch({
        type: clientTypes.GET_PROFILE_DATA_SUCCESS,
        payload: res.data?.result ?? [],
        isLoading: false,
        msg: res.data.message ?? "",
      });
    } catch (error) {
      dispatch({
        type: clientTypes.GET_PROFILE_DATA_FAILED,
        payload: [],
        isLoading: false,
        msg: (error && error?.message) ?? "",
      });
    }
  };
};

export const getCmsData = (type) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: clientTypes.GET_CMS_DATA_PENDING,
        isLoading: true,
      });
      const res = await GET(
        `${ApiUrl.CLIENT_CMS_DATA_GET}?content_type=${type}`
      );
      dispatch({
        type: clientTypes.GET_CMS_DATA_SUCCESS,
        payload: res.data?.result ?? [],
        isLoading: false,
        msg: res.data.message ?? "",
      });
    } catch (error) {
      dispatch({
        type: clientTypes.GET_CMS_DATA_FAILED,
        payload: [],
        isLoading: false,
        msg: (error && error?.message) ?? "",
      });
    }
  };
};
